const schema = () => ({
  type: "object",
  required: [],
  properties: {
    doctor_ids: {
      type: "array",
      title: "پزشک ها",
      items: {
        type: "string",
      },
    },
    unit_ids: {
      type: "array",
      title: "کلینیک ها",
      items: {
        type: "string",
      },
    },
  },
});

export default schema;
